import {
    UserReferralApiV1UserReferralInfoGetParams,
    UserReferralBalanceIncreaseListOutputDTO,
    UserReferralInfoDTO,
    UserReferralListApiV1UserReferralGetParams,
} from '../swagger/dto'
import { getRequest } from './config'
import { USER_REFERRAL, USER_REFERRAL_INFO } from './endpoints.constants'

export const getUserRefferalInfo = async (params?: UserReferralApiV1UserReferralInfoGetParams) => {
    const response = await getRequest<UserReferralInfoDTO>(USER_REFERRAL_INFO, params)

    return response.data
}

export const getUserRefferals = async (params?: UserReferralListApiV1UserReferralGetParams) => {
    const response = await getRequest<UserReferralBalanceIncreaseListOutputDTO>(USER_REFERRAL, {
        limit: 10,
        offset: 0,
        ...params,
    })

    return response.data.objects
}
